import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/site';
import FaqAccordion from '@/components/feature/FaqAccordion';
import SectionHeading from '@/components/feature/SectionHeading';

export default function FaqSection() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-content px-4 md:px-6 py-14 md:py-20">
        <SectionHeading
          eyebrow="常见问题"
          title="关于这份档案，你可能想问"
          desc="如果这里没有回答你的疑问，欢迎在「关于我们」页面找到联系方式。"
        />
        <FaqAccordion items={faqs} />
        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-lg border border-background-200 bg-background-50 p-6 sm:flex-row">
          <p className="text-sm text-foreground-700">
            想了解档案整理的标准与流程？我们在关于页面写清楚了。
          </p>
          <Link
            to="/about"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-5 py-2.5 text-sm text-primary-600 transition-colors hover:bg-primary-50"
          >
            前往关于我们
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}